import { CommonService, ReduxService } from 'dashboard-services/services';

import { basicCustomInsightActions, basicCustomInsightConsts } from 'actions/modules/insight';

import { emailExportInitialState } from './emailExport';

const isTile = prevSelectedTile => prevSelectedTile !== undefined && !String(prevSelectedTile).startsWith("FOOTER") && !String(prevSelectedTile).startsWith("HEADER") && typeof prevSelectedTile === "number"
export const basicCustomReducer = (state , action) => {
  switch (action.type) {
    case basicCustomInsightActions.ADD_TILE: {
      // Engine tiles send the Builder snapshot (`content` + `tileId`); other tiles keep the legacy `tile` payload.
      if(action.content) {
        const tileIndex = action.content.tiles.findIndex(tile => tile.id === action.tileId)

        return ReduxService.updateObject(state, {
          content: action.content,
          datapreps: isTile(state.prevSelectedTile) ? updateDataPreps(state.datapreps, tileIndex) : state.datapreps,
          dataRefAreaLeft: isTile(state.prevSelectedTile) ? updateDataRef(state.dataRefAreaLeft, tileIndex) : state.dataRefAreaLeft,
          dataRefAreaRight: isTile(state.prevSelectedTile) ? updateDataRef(state.dataRefAreaRight, tileIndex) : state.dataRefAreaRight,
          selectedTile: tileIndex
        })
      }

      return ReduxService.updateObject(state, { 
        content: ReduxService.updateObject(state.content, { 
          tiles: (state.content?.tiles || []).add(action.tile, state.prevSelectedTile !== undefined ? state.prevSelectedTile + 1 : undefined) 
        }),
        datapreps: isTile(state.prevSelectedTile) ? updateDataPreps(state.datapreps, state.prevSelectedTile + 1) : state.datapreps,
        dataRefAreaLeft: isTile(state.prevSelectedTile) ? updateDataRef(state.dataRefAreaLeft, state.prevSelectedTile + 1) : state.dataRefAreaLeft,
        dataRefAreaRight: isTile(state.prevSelectedTile) ? updateDataRef(state.dataRefAreaRight, state.prevSelectedTile + 1) : state.dataRefAreaRight,
        selectedTile: isTile(state.prevSelectedTile) && (state.content.tiles || []).length > 0 ? state.prevSelectedTile + 1 : (state.content.tiles || []).length
      })
    }
    case basicCustomInsightActions.SET_TILE_PARTNER_ASSET: {
      const currentAssets = state.tilePartnerAssets || {},
            tileAssets = currentAssets[action.tileId] || {},
            nextTileAssets = { ...tileAssets, [action.partnerId]: { file: action.file, imageUrl: action.imageUrl } }

      return ReduxService.updateObject(state, {
        tilePartnerAssets: {
          ...currentAssets,
          [action.tileId]: nextTileAssets
        }
      })
    }
    case basicCustomInsightActions.CLEAR_TILE_PARTNER_ASSET: {
      const currentAssets = state.tilePartnerAssets || {}
      if(action.tileId === undefined) {
        return Object.keys(currentAssets).length === 0
          ? state
          : ReduxService.updateObject(state, { tilePartnerAssets: {} })
      }

      const tileAssets = currentAssets[action.tileId]
      if(!tileAssets) {
        return state
      }

      if(action.partnerId === undefined) {
        return ReduxService.updateObject(state, { tilePartnerAssets: currentAssets.removeProp(action.tileId) })
      }

      if(!tileAssets[action.partnerId]) {
        return state
      }

      const nextTileAssets = tileAssets.removeProp(action.partnerId),
            nextAssets = Object.keys(nextTileAssets).length === 0
              ? currentAssets.removeProp(action.tileId)
              : { ...currentAssets, [action.tileId]: nextTileAssets }
      return ReduxService.updateObject(state, { tilePartnerAssets: nextAssets })
    }
    case basicCustomInsightActions.DUPLICATE_TILE: {
      if(action.content) {
        return ReduxService.updateObject(state, {
          content: action.content,
          datapreps: updateDataPreps(state.datapreps, action.index),
          dataRefAreaLeft: updateDataRef(state.dataRefAreaLeft, action.index),
          dataRefAreaRight: updateDataRef(state.dataRefAreaRight, action.index),
        })
      }

      return ReduxService.updateObject(state, { 
        content: ReduxService.updateObject(state.content, { 
          tiles: (state.content?.tiles || []).add(ReduxService.updateObject(ReduxService.cloneObject(state.content?.tiles[action.index]), { title: action.newTitle, id: CommonService.generateUID() }), action.index + 1)
        }),
        datapreps: updateDataPreps(state.datapreps, action.index),
        dataRefAreaLeft: updateDataRef(state.dataRefAreaLeft, action.index),
        dataRefAreaRight: updateDataRef(state.dataRefAreaRight, action.index),
      })
    }
    case basicCustomInsightActions.ON_CHANGE_TILE: {
      if(state.content.tiles?.[action.index]?.[action.name] !== action.value) {
        return ReduxService.updateObject(state, { 
          content: ReduxService.updateObject(state.content, { tiles: state.content.tiles?.updateInList({ [action.name]: action.value }, action.index) || state.content.tiles })
        })
      }
      return state;
    }
    case basicCustomInsightActions.ON_CHANGE_TILE_ITEM: {
      if(state.content.tiles?.[action.index]?.[action.itemName]?.[action.name] !== action.value) {
        return ReduxService.updateObject(state, {
          content: ReduxService.updateObject(state.content, {
            tiles: state.content.tiles?.updateInList({
              [action.itemName]: ReduxService.updateObject(state.content.tiles?.[action.index]?.[action.itemName], { [action.name]: action.value })
            }, action.index) || state.content.tiles
          })
        })
      }
      return state;
    }
    case basicCustomInsightActions.ON_CHANGE_TILE_OVERWRITE_ITEM: {
      if(state.tileOverwrite?.[action.tileId]?.[action.name] !== action.value) {
        return ReduxService.updateObject(state, {
          tileOverwrite: ReduxService.updateObject(state.tileOverwrite, {
            [action.tileId]: ReduxService.updateObject(state.tileOverwrite?.[action.tileId], { [action.name]: action.value })
          })
        })
      }
      return state;
    }
    case basicCustomInsightActions.DELETE_TILE: {
      if(action.content) {
        return ReduxService.updateObject(state, {
          content: action.content,
          datapreps: updateDataPreps(state.datapreps, action.index, { isRemove: true }),
          dataRefAreaLeft: updateDataRef(state.dataRefAreaLeft, action.index, { isRemove: true }),
          dataRefAreaRight: updateDataRef(state.dataRefAreaRight, action.index, { isRemove: true }),
          selectedTile: isTile(state.selectedTile - 1) && (state.content.tiles || []).length > 0 ? state.selectedTile - 1 : (state.content.tiles || []).length
        })
      }

      return ReduxService.updateObject(state, { 
        content: ReduxService.updateObject(state.content, { 
          tiles: (state.content?.tiles || []).remove(action.index) 
        }),
        datapreps: updateDataPreps(state.datapreps, action.index, { isRemove: true }),
        dataRefAreaLeft: updateDataRef(state.dataRefAreaLeft, action.index, { isRemove: true }),
        dataRefAreaRight: updateDataRef(state.dataRefAreaRight, action.index, { isRemove: true }),
        selectedTile: isTile(state.selectedTile - 1) && (state.content.tiles || []).length > 0 ? state.selectedTile - 1 : (state.content.tiles || []).length
      })
    }

    case basicCustomInsightActions.ADD_HEADER_BOX:
      return ReduxService.updateObject(state, { content: ReduxService.updateObject(state.content, { headerBoxes: (state.content?.headerBoxes || []).add(ReduxService.updateObject(Object.fromEntries(Object.entries(basicCustomInsightConsts.EMPTY_HEADER_BOX).map(([k, v]) => [k, v?.defaultValue])), { title: `Summary ${(state.content?.headerBoxes || []).length + 1}` })) }) })
    case basicCustomInsightActions.DUPLICATE_HEADER_BOX:
      return ReduxService.updateObject(state, { content: ReduxService.updateObject(state.content, { headerBoxes: (state.content?.headerBoxes || []).add(ReduxService.updateObject(state.content?.headerBoxes[action.index])) }) })
    case basicCustomInsightActions.REORDER_HEADER_BOX: 
      return ReduxService.updateObject(state, { content: ReduxService.updateObject(state.content, { headerBoxes: (state.content?.headerBoxes || []).moveItem(action.from, action.to) }) })
    case basicCustomInsightActions.ON_CHANGE_HEADER_BOX: {
      if(state.content?.headerBoxes?.[action.index]?.[action.name] !== action.value) {
        return ReduxService.updateObject(state, { 
          content: ReduxService.updateObject(state.content, { 
            headerBoxes: (state.content?.headerBoxes || []).updateInList({ [action.name]: action.value }, action.index) 
          })
        })
      }
      return state;
    }
    case basicCustomInsightActions.DELETE_HEADER_BOX:
      return ReduxService.updateObject(state, { content: ReduxService.updateObject(state.content, { headerBoxes: (state.content?.headerBoxes || []).remove(action.index) }) })
    
    case basicCustomInsightActions.ADD_FOOTER:
      return ReduxService.updateObject(state, { content: ReduxService.updateObject(state.content, { footer: Object.fromEntries(Object.entries(basicCustomInsightConsts.EMPTY_FOOTER).map(([k, v]) => [k, v?.defaultValue])) }) })
    case basicCustomInsightActions.ON_CHANGE_FOOTER: {
      if(state.content.footer?.[action.name] !== action.value) {
        return ReduxService.updateObject(state, { 
          content: ReduxService.updateObject(state.content, { footer: ReduxService.updateObject(state.content.footer, { [action.name]: action.value }) })
        })
      }
      return state;
    }
    case basicCustomInsightActions.DELETE_FOOTER:
      return ReduxService.updateObject(state, { content: ReduxService.updateObject(state.content, { footer: undefined }) })

    case basicCustomInsightActions.ADD_FOOTER_BUTTON:
      return ReduxService.updateObject(state, { content: ReduxService.updateObject(state.content, { footer: ReduxService.updateObject(state.content.footer, { buttons: (state.content.footer?.buttons || []).add({ text: `Button${(state.content.footer?.buttons || []).length + 1}`, type: undefined }) }) }) })
    case basicCustomInsightActions.ON_CHANGE_FOOTER_BUTTON: {
      if(state.content.footer?.buttons?.[action.index]?.[action.name] !== action.value) {
        return ReduxService.updateObject(state, { 
          content: ReduxService.updateObject(state.content, { 
            footer: ReduxService.updateObject(state.content.footer, {
              buttons: state.content.footer.buttons.updateInList({ 
                [action.name]: action.value 
              }, action.index) 
            })
          })
        })
      }
      return state;
    }
    case basicCustomInsightActions.DELETE_FOOTER_BUTTON:
      return ReduxService.updateObject(state, { content: ReduxService.updateObject(state.content, { footer: ReduxService.updateObject(state.content.footer, { buttons: (state.content?.footer?.buttons || []).remove(action.index) }) }) })
    case basicCustomInsightActions.REORDER_FOOTER_BUTTON:
      return ReduxService.updateObject(state, { content: ReduxService.updateObject(state.content, { footer: ReduxService.updateObject(state.content.footer, { buttons: (state.content?.footer?.buttons || []).moveItem(action.from, action.to) }) }) })
    case basicCustomInsightActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value, prevSelectedTile: action.name === "selectedTile" ? state.selectedTile : state.prevSelectedTile })
      }
      return state;
    }
    case basicCustomInsightActions.ON_CHANGE_CONTENT: {
      if(state.content[action.name] !== action.value) {
        return ReduxService.updateObject(state, { content: ReduxService.updateObject(state.content, { [action.name]: action.value }) })
      }
      return state;
    }
    case basicCustomInsightActions.ON_CHANGE_INFO: {
      if(state.info?.[action.name] !== action.value) {
        return ReduxService.updateObject(state, { info: ReduxService.updateObject(state.info, { [action.name]: action.value }) })
      }
      return state;
    }
    case basicCustomInsightActions.ON_CHANGE_INFO_FIELD:{
      if(state.info.fields) {
        const fieldIndex = state.info.fields.findIndex(field => field.name === action.name)
        if(fieldIndex > -1) {
          return ReduxService.updateObject(state, { info: ReduxService.updateObject(state.info, { fields: state.info.fields.updateInList({ value: action.value },  fieldIndex) }) })
        }
        return ReduxService.updateObject(state, { info: ReduxService.updateObject(state.info, { fields: state.info.fields.add({ value: action.value, name: action.name }) }) })
      }
      return state;
    }
    case basicCustomInsightActions.ON_ADD_TILE_LIST:
      return ReduxService.updateObject(state, { 
        content: ReduxService.updateObject(state.content, { tiles: state.content.tiles.updateInList(
          { [action.listName]: (state.content.tiles[action.tileIndex][action.listName] || []).add(action.item) }, 
        action.tileIndex) })
      })
    case basicCustomInsightActions.ON_CHANGE_TILE_LIST: {
      if(state.content.tiles[action.tileIndex]?.[action.listName]?.[action.listIndex]?.[action.name] !== action.value) {
        return ReduxService.updateObject(state, { 
          content: ReduxService.updateObject(state.content, { tiles: state.content.tiles.updateInList(
            { [action.listName]: state.content.tiles[action.tileIndex][action.listName].updateInList({ [action.name]: action.value }, action.listIndex) }, 
          action.tileIndex) })
        })
      }
      return state;
    }
    case basicCustomInsightActions.ON_REMOVE_TILE_LIST:
      return ReduxService.updateObject(state, { 
        content: ReduxService.updateObject(state.content, { tiles: state.content.tiles.updateInList(
          { [action.listName]: state.content.tiles[action.tileIndex][action.listName].remove(action.listIndex) }, 
        action.tileIndex) })
      })
    case basicCustomInsightActions.ON_REORDER_TILE_LIST: 
      return ReduxService.updateObject(state, { 
        content: ReduxService.updateObject(state.content, { 
          tiles: state.content.tiles.updateInList(
            { [action.listName]: state.content.tiles[action.tileIndex][action.listName].moveItem(action.from, action.to) },
            action.tileIndex) 
          })
      })
    case basicCustomInsightActions.SET_DATA_PREP:
      return ReduxService.updateObject(state, { datapreps: ReduxService.updateObject(state.datapreps, { [action.index]: action.dataprep }) })
    case basicCustomInsightActions.SET_SHORT_DATA_PREP:
      return ReduxService.updateObject(state, { shortDatapreps: ReduxService.updateObject(state.shortDatapreps, { [action.index]: action.dataprep }) })
    case basicCustomInsightActions.CLEAR_WITH_ID:
      return ReduxService.updateObject(state, {
        activePanel: undefined,
        activeView: undefined,
        activeFormulaTileId: undefined,
        activeFormulaColumnId: undefined,
        hasAllTilesPublicAccess: false,
        content: {},
        info: { fid: state.info?.fid },
        datapreps: {},
        editActive: false,
        userSelectableDropdowns: {},
        hasInsightWriteAccess: undefined,
        template: undefined,
        templateTaskDef: undefined,
        templateParams: {},
        image: undefined,
        dataRefAreaLeft: [],
        dataRefAreaRight: [],
        symbols: {},
        values: [],
        metadataMap: {},
        choosenDate: undefined,
        selectedTile: undefined,
        prevSelectedTile: undefined,
        isSingleTile: false,
        inputParams: {},
        summaryData: [],
        tileName: undefined,
        expanded: undefined,
        emailExportState: emailExportInitialState,
        tileOverwrite: {}
      })
    default:
      return undefined;
  }
}

const updateDataPreps = (datapreps, copiedItemIndex, { isRemove = false } = {}) => {
  const newDataPreps = {}
  Object.entries(datapreps).forEach(([index, value]) => {
    if(Number(copiedItemIndex) < Number(index)) {
      newDataPreps[Number(index) + (isRemove ? -1 : 1)] = value
    } else if(Number(copiedItemIndex) === Number(index)) {
      if(!isRemove) {
        newDataPreps[Number(index)] = value
        newDataPreps[Number(index) + 1] = value
      }
    } else {
      newDataPreps[Number(index)] = value
    }
  })
  return newDataPreps;
}

const updateDataRef = (dataRefs, copiedItemIndex, { isRemove = false } = {}) => {
  const newRefs = []
  dataRefs.forEach((item, index) => {
    if(Number(copiedItemIndex) !== Number(index)) {
      newRefs.push(item)
    } else {
      if(!isRemove) {
        newRefs.push(item)
      }
    }
  })
  return newRefs;
}
